import {RegistrationWorkStatus} from './types';

const MY_TAX_APP_URL = 'https://lknpd.nalog.ru/';
const FIND_TAX_OFFICE_URL = 'https://www.nalog.gov.ru/rn77/service/service_inspectors/';
const FNS_IP_REGISTRATION_URL = 'https://www.nalog.gov.ru/rn77/related_activities/registration_ip_yl/';

export type HowToBecomeAction = {
	label: string;
	url: string;
};

export type HowToBecomeStep = {
	label: string;
	title: string;
	text: string;
	action?: HowToBecomeAction;
};

export type HowToBecomeSection = {
	title: string;
	heading?: string;
	text?: string;
	steps?: HowToBecomeStep[];
};

export type HowToBecomeContent = {
	title: string;
	intro?: string;
	sections?: HowToBecomeSection[];
	action?: HowToBecomeAction;
};

const SELF_EMPLOYMENT_HOW_TO: HowToBecomeContent = {
	title: 'Как стать самозанятым',
	sections: [
		{
			title: 'Для граждан РФ',
			heading: 'Пройдите регистрацию в приложении «Мой налог»',
			text: 'Вам понадобится паспорт и ИНН или подтверждённая учётная запись на Госуслугах',
		},
		{
			title: 'Для иностранцев',
			steps: [
				{
					label: 'Шаг 1',
					title: 'Станьте налогоплательщиком Российской Федерации',
					text: 'Вам нужно получить ИНН и доступ в личный кабинет налогоплательщика. Сделать это можно в любой налоговой инспекции РФ',
					action: {
						label: 'Найти ближайшую инспекцию',
						url: FIND_TAX_OFFICE_URL,
					},
				},
				{
					label: 'Шаг 2',
					title: 'Пройдите регистрацию в приложении «Мой налог»',
					text: 'Выберите регистрацию через личный кабинет физического лица. Для этого вам понадобится ИНН',
					action: {
						label: 'Перейти в Мой налог',
						url: MY_TAX_APP_URL,
					},
				},
			],
		},
	],
};

const INDIVIDUAL_HOW_TO: HowToBecomeContent = {
	title: 'Как стать физическим лицом',
	intro:
		'По договору ГПХ. Любой человек — и гражданин РФ и иностранец — может работать с юрлицами по договорам гражданско-правового характера. Для этого не нужно регистрировать отдельные статусы: достаточно получить ИНН и находиться на территории России легально.',
};

const INDIVIDUAL_ENTREPRENEUR_HOW_TO: HowToBecomeContent = {
	title: 'Как стать ИП',
	intro:
		'Индивидуальный предприниматель — физическое лицо (гражданин РФ или иностранец с регистрацией в РФ), зарегистрированное и осуществляющее деятельность в установленном порядке. Из обязательного: внесение взносов, уплата налогов в размере от 6 или 13% в зависимости от режима налогообложения и формирование отчётности. В статусе ИП можно оказывать услуги заказчикам в приложении Рокет Ворк.',
	sections: [
		{
			title: 'Пройти государственную регистрацию ИП',
			text: 'Подать документы для регистрации можно лично, по почте или в электронном виде: на сайте ФНС, через госуслуги или в банке, который работает с предпринимателями',
		},
	],
	action: {
		label: 'Перейти на сайт ФНС',
		url: FNS_IP_REGISTRATION_URL,
	},
};

export const HOW_TO_BECOME_BY_STATUS: Record<RegistrationWorkStatus, HowToBecomeContent> = {
	self_employment: SELF_EMPLOYMENT_HOW_TO,
	individual: INDIVIDUAL_HOW_TO,
	individual_entrepreneur: INDIVIDUAL_ENTREPRENEUR_HOW_TO,
};

export const getHowToBecomeContent = (
	workStatus: RegistrationWorkStatus | null,
): HowToBecomeContent => {
	return HOW_TO_BECOME_BY_STATUS[workStatus ?? 'self_employment'];
};
